import React from "react";
import { useSelector } from "react-redux";

const GuestDropDown = () => {
  const { adults } = useSelector((store) => store.booking);

  return (
    <div
      className="bg-[#F5F7FA] font-outfit flex justify-center items-center
      h-[55px] gap-[12px] rounded-[8px] px-3"
    >
      <span className="text-[#FF9500] font-[600] text-[28px] leading-[24px]">
        {adults < 10 ? `0${adults}` : adults}
      </span>

      <span
        className="uppercase text-[#667085] font-[600] text-[10px]
        flex flex-col leading-[15px] tracking-[1px]"
      >
        <span> Total </span>
        <span> GUEST </span>
      </span>
    </div>
  );
};

export default GuestDropDown;
